/* eslint-disable no-unused-vars */

export const imgDomain = "https://mini-project-cdn.oss-cn-shenzhen.aliyuncs.com/";
